export const FRONT_ACLS_BRAND_STAFF = {
	DASHBOARD: {
		KPI_COMPENSATED_EMISSIONS:
			'dashboard:front:kpi_compensated_emissions',
		KPI_TOTAL_COMPONSATION:
			'dashboard:front:kpi_total_compensation',
		KPI_FINANCING_OF_ADDITIONALITY:
			'dashboard:front:kpi_financing_of_additionality',
		REQUEST_CARBON_ASSESSMENT:
			'dashboard:front:request_carbon_assessment',
		FILTER_DATE: 'dashboard:front:filter_date',
		DONUTCHART: 'dashboard:front:donut_chart',
		LAST_OFFSETS_LIST:
			'dashboard:front:last_offsets_list',

		LAST_NEWS: 'dashboard:front:last_news',
	},
	OFFSETS: {
		FILTER: 'offsets:front:filter',
		FILTER_DATE: 'offsets:front:filter_date',
	},
	MEASURABILITIES: {
		FILTER: 'measurabilities:front:filter',
		FILTER_COUNTRIES:
			'measurabilities:front:filter_countries',
		FILTER_TECHNOLOGIES:
			'measurabilities:front:filter_technologies',
		FILTER_RANGE_PRICE_PER_TONE:
			'measurabilities:front:filter_range_price_per_tonne',
		FILTER_RANGE_AVAILABLE_STOCK:
			'measurabilities:front:filter_range_available_stock',
		TOGGLE_VIEW_MODE:
			'measurabilities:front:toggle_view_grid_list',
		EDIT_BUTTON: 'measurabilities:front:edit_button',
		TAB_GENERAL_INFORMATIONS:
			'measurabilities:front:tab_general_information',
		TAB_TRANSACTION_HISTORY:
			'measurabilities:front:tab_transaction_history',
	},
	ADDITIONALITIES: {
		FILTER: 'additionalities:front:filter',
		FILTER_COUNTRIES:
			'additionalities:front:filter_countries',
		FILTER_TECHNOLOGIES:
			'additionalities:front:filter_technologies',
		FILTER_RANGE_PRICE_PER_TONE:
			'additionalities:front:filter_range_price_per_tonne',
		FILTER_RANGE_AVAILABLE_STOCK:
			'additionalities:front:filter_range_available_stock',
		TOGGLE_VIEW_MODE:
			'additionalities:front:toggle_view_grid_list',
		EDIT_BUTTON: 'additionalities:front:edit_button',
		TAB_GENERAL_INFORMATIONS:
			'additionalities:front:tab_general_information',
		TAB_TRANSACTION_HISTORY:
			'additionalities:front:tab_transaction_history',
	},
} as const;
